import React from "react";
import {connect} from 'react-redux'
import {Link} from "react-router-dom";

//Icons
import Fingerprint from "@material-ui/icons/Fingerprint";
import AddIcon from "@material-ui/icons/Add";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

// core components

import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import Table from "components/Table/Table.jsx";
import LinearProgress from '@material-ui/core/LinearProgress';
import Checkbox from "components/Checkbox/Checkbox";

//Table actions
import Actions from 'views/Tables/Actions'

//Approve popUp
import ConfirmAlert from 'components/Alert/Confirm'
import ProgressAlert from 'components/Alert/Progress'
import SuccessAlert from 'components/Alert/Success'

// Actions
import {userFetch, userFilter, userRemove} from 'actions/users'
class List extends React.Component {
  selected=[]
  state = {
    selected: []
  }
  componentDidMount() {
    this
      .props
      .fetch()
  }
  select(id) {

    let select = []
    if (Array.isArray(id))
      select = (this.state.selected.length > 0)
        ? []
        : id
    else if (this.state.selected.indexOf(id) > -1)
      select = this.state.selected.filter((e) => e !== id)
    else
      select = this
        .state
        .selected
        .concat(id)
    this.setState({
      ...this.state,
      selected: select
    })
    
  }
  add() {
    
  }
  confirmDelete() {
    if(this.selected.length===0){
      this.props.fetch();
      this.setState({
        ...this.state,
        selected:[],
        alert: <SuccessAlert
          title={`Done!`}
          onConfirm={()=>{this.setState({...this.state,alert:false});}}
        />
      });
      return false;
    }
    this.setState({
      ...this.state,
      alert: <ProgressAlert
      value={100-((this.selected.length*100)/this.state.selected.length)}
      title={`Delete Users (${this.state.selected.length-this.selected.length+'/'+this.state.selected.length})`}
      />
    });
    this.props.remove(this.selected[0])
      .then((e)=>{
        this.selected=this.selected.slice(1);
        this.confirmDelete();
      })
  }
  delete() {
    // confirm()
    this.setState({
      ...this.state,
      alert: <ConfirmAlert
        text={`You want to delete user with id ${this.state.selected[0]}`}
        onCancel={()=>this.setState({...this.state,alert:false})}
        onConfirm={()=>{
          this.selected=this.state.selected.slice(0);
          this.confirmDelete();
        }}
      />
    });
  }
  filter(filter){
    this.setState({...this.state,selected:[]})
    this.props.filter({
      ...this.props.users.pageable,
      ...filter,
      page: filter.size 
        ? 0 
        : filter.page !== undefined ? filter.page : this.props.users.pageable.page
    })
    this.props.fetch()
  }
  render() {
    const {match, users} = this.props;
    const selected = this.state.selected
    
    return (
      <GridContainer style={{marginBottom: '30px'}}>
        <GridItem xs={12}>
      <Card>
        {this.state.alert}
        {
        (!users.isFetching)?
        //Top actions (pgination/limit/add/remove/edit)
        <Actions
          onPagination={(page)=>this.filter({page:page-1})}
          limit={users.pageable.size}
          limitOptions={[10,100,200]}
          onLimitation={(page)=>this.filter({size:page})}
          pagination={users.pageable.totalPages>1?{
            pages:users.pageable.totalPages,
            current:users.pageable.page+1,
          }:false}
          // title={this.getTableTitle()}
          dark={selected.length>0}
          icon={<Fingerprint/>}
          actions={{
          add: (selected.length===0)
            ? <Link to={`${match.path}/add/`}>
                <IconButton>
                  <AddIcon/>
                </IconButton>
              </Link>
            : '',
            delete: (selected.length>0) && this.props.permissions.includes('USERS_DELETE')
              ? <IconButton onClick={this.delete.bind(this)}><DeleteIcon/></IconButton>
              : '',
            edit: (selected.length===1)
              ? <Link to={`${match.path}/${this.state.selected[0]}`}>
                  <IconButton>
                      <EditIcon/>
                  </IconButton>
                </Link>
              : ''
        }}/>:''}

        <CardBody>
          {(users.isFetching)
            ? <LinearProgress color="primary"/>
            : (
              //Main table
              <Table
                tableHeaderColor="primary"
                sort={users.pageable.sort}
                onSort={(e)=>this.filter({sort:{[e]:users.pageable.sort[e]==='desc'?'asc':'desc'}}) }
                tableHead={{
                  checkbox: <Checkbox props = {{ onClick:()=>this.select(Object.keys(users.list)), checked:this.state.selected.length===Object.keys(users.list).length }}/>,
                  userId: "#",
                  login: "Login",
                  name: "Name",
                  email: "Email",
                  phone: "Phone"
                }}
                tableData={Object
                .keys(users.list)
                .map(e => [
                    /*<Checkbox props = {{ onClick:()=>this.select(e), checked:this.state.selected.indexOf(e)>-1 }}/>,*/
                    <Checkbox props = {{ onClick:()=>this.select(users.list[e].userId), checked:this.state.selected.indexOf(users.list[e].userId)>-1 }}/>,
                    users.list[e].userId,
                    users.list[e].login,
                    users.list[e].name,
                    users.list[e].email,
                    users.list[e].phoneNumber ] )}/>
            )}
        </CardBody>
       { 
         (!users.isFetching)
        ?<Actions
            onPagination={(page)=>this.filter({page:page-1})}
            pagination={users.pageable.totalPages>1?{
              pages:users.pageable.totalPages,
              current:users.pageable.page+1,
            }:false}
        />:''}
      </Card>
      </GridItem>
      </GridContainer>
    );
  }
}
const mapStateToProps = ( state ) => ({
  users: state.users,
  permissions: state.auth.permissions
})
const mapDispatchToProps = ( dispatch ) => ({
  fetch: (filter) => dispatch(userFetch(filter)),
  filter: (filter) => dispatch(userFilter(filter)),
  remove: (id) => dispatch(userRemove(id))
})
export default(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/Users/List.jsx